import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import omit from "lodash/omit";

import { sessionPackQueryKeys } from "./sessionPackQueryKeys";

export function useSessionPackEdit({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      sessionPackId,
      patchedFields,
    }: {
      sessionPackId: number;
      patchedFields: Parameters<
        ApiType["creditPackApi"]["update"]
      >[1]["patchedFields"] & {
        termsConditions?: any;
      };
    }) => {
      await api.creditPackApi.update(sessionPackId, {
        patchedFields: omit(patchedFields, "termsConditions"),
        termsAndConditionsBlob: patchedFields["termsConditions"],
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sessionPackQueryKeys.all() });
    },
  });
}
